import { render } from "./BaseButtonShop.vue?vue&type=template&id=1ac415ac&scoped=true&ts=true"
import script from "./BaseButtonShop.vue?vue&type=script&lang=ts"
export * from "./BaseButtonShop.vue?vue&type=script&lang=ts"

import "./BaseButtonShop.scss?vue&type=style&index=0&id=1ac415ac&scoped=true&lang=scss"

import exportComponent from "/Users/agnisvegners/Projects/anatomynext/hpc-new/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ac415ac"]])

export default __exports__